const PRIORITY_STYLES = {
    high: {
        label: 'High',
        className: 'bg-red-50 text-red-700 border border-red-100',
    },
    medium: {
        label: 'Medium',
        className: 'bg-amber-50 text-amber-700 border border-amber-100',
    },
    low: {
        label: 'Low',
        className: 'bg-emerald-50 text-emerald-700 border border-emerald-100',
    },
};

const getPriorityMeta = (priority) => {
    const normalizedPriority = String(priority || 'medium').toLowerCase();
    return PRIORITY_STYLES[normalizedPriority] || PRIORITY_STYLES.medium;
};

const getRowStatusMeta = (row, item) => {
    if (item.status?.id === 41) {
        return {
            label: 'Created',
            className: 'bg-emerald-50 text-emerald-700 border border-emerald-100',
        };
    }

    if (row.ready_to_create) {
        return {
            label: 'Ready to create',
            className: 'bg-blue-50 text-blue-700 border border-blue-100',
        };
    }

    return {
        label: 'Pending completion',
        className: 'bg-amber-50 text-amber-700 border border-amber-100',
    };
};

export const Columns = (
    selectedRows,
    setSelectedRows,
    openModalAdd,
    item
) => {

    const handleCheckboxChange = (row, checked) => {
        if (checked) {
            if (!selectedRows.some(r => r.ai_row_id === row.ai_row_id)) {
                setSelectedRows([...selectedRows, row]);
            }
        } else {
            setSelectedRows(selectedRows.filter(r => r.ai_row_id !== row.ai_row_id));
        }
    };

    const columns = [
        {
            id: 'title',
            name: 'Service',
            selector: row => `${row.title || row.description || ''}`,
            grow: 2,
            cell: row => {
                const statusMeta = getRowStatusMeta(row, item);
                return (
                    <div className="flex flex-col gap-2 py-2">
                        <div className="flex flex-wrap items-center gap-2">
                            <p className="font-medium text-cs-dark">{row.title || 'Suggested service'}</p>
                            <span className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusMeta.className}`}>
                                {statusMeta.label}
                            </span>
                        </div>
                        <p className="text-xs text-cs-muted">{row.description || 'No description provided by AI.'}</p>
                    </div>
                );
            },
        },
        {
            id: 'priority',
            name: 'Priority',
            selector: row => `${row.priority || 'medium'}`,
            cell: row => {
                const priorityMeta = getPriorityMeta(row.priority);
                return (
                    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${priorityMeta.className}`}>
                        {priorityMeta.label}
                    </span>
                );
            },
        },
        {
            id: 'estimated_km',
            name: 'Estimated KM',
            selector: row => `${row.estimated_km ?? '-'}`,
            cell: row => (
                <span className="text-sm font-medium text-cs-dark">
                    {row.estimated_km ?? '—'}
                </span>
            ),
        },
        {
            id: 'supplier_type_id',
            name: 'Supplier Type',
            selector: row => `${row.supplier_type_name || row.supplier_type_id || '-'}`,
            cell: row => (
                row.supplier_type_name ? (
                    <span className="inline-flex rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-medium text-slate-700">
                        {row.supplier_type_name}
                    </span>
                ) : (
                    <span className="text-xs text-cs-muted">
                        {row.supplier_type_id ? `Type #${row.supplier_type_id}` : 'Not assigned'}
                    </span>
                )
            ),
        },
        {
            id: 'select',
            name: item.status?.id !== 41 ? 'Actions' : 'Status',
            button: true,
            width: '230px',
            cell: row => {
                const isChecked = selectedRows.some(r => r.ai_row_id === row.ai_row_id);
                const statusMeta = getRowStatusMeta(row, item);

                return (
                    <div className="flex items-center justify-end gap-3 py-1">
                        {item.status?.id !== 41 ? (
                            <>
                                <button
                                    onClick={() => openModalAdd(row)}
                                    className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 transition hover:bg-slate-50"
                                >
                                    <i className="fas fa-pen text-[11px]"></i>
                                    Edit
                                </button>

                                {row.ready_to_create ? (
                                    <label className="inline-flex items-center gap-2 text-xs font-medium text-cs-dark">
                                        <input
                                            type="checkbox"
                                            className="h-4 w-4 rounded border-gray-300 text-blue-600"
                                            checked={isChecked}
                                            onChange={e => handleCheckboxChange(row, e.target.checked)}
                                        />
                                        Select
                                    </label>
                                ) : (
                                    <span className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusMeta.className}`}>
                                        Complete modal first
                                    </span>
                                )}
                            </>
                        ) : (
                            <span className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold ${statusMeta.className}`}>
                                Service order created
                            </span>
                        )}
                    </div>
                );
            },
        },
    ];

    return columns;
};
